import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToolsService} from '../tools/tools.service';

@Injectable({
  providedIn: 'root'
})
export class GraphemeService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService
  ) {
  }

  getLetters() {
    return this.http.get(`${this.toolsSrv.getApiTargetEndpoint()}graphemes/letters`).toPromise();
  }
}
